module.exports = __webpack_public_path__ + "static/media/Mobile_Carrosel_BIG_DATA_E_DATA_MINING.eae5fb31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/bigData_Mining/Mobile_Carrosel_BIG_DATA_E_DATA_MINING.png
// module id = 200
// module chunks = 0